export * from "./Acl";
export * from "./AcsesCommunication";
export * from "./Agreement";
export * from "./AiTranslation";
export * from "./AnswerItem";
export * from "./Appointment";
export * from "./AppointmentLog";
export * from "./AppointmentNote";
export * from "./AppointmentStatus";
export * from "./Appversion";
export * from "./Article";
export * from "./Base";
export * from "./Bitbucket";
export * from "./Brand";
export * from "./CameraAppVersion";
export * from "./Car";
export * from "./CarCheck";
export * from "./CarCheckEvent";
export * from "./CarNote";
export * from "./CheckIn";
export * from "./Checklist";
export * from "./CommunicationSetting";
export * from "./Customer";
export * from "./CustomerCommunication";
export * from "./CustomerCommunicationEvent";
export * from "./CustomerNote";
export * from "./Dealer";
export * from "./DealerDocumentation";
export * from "./DealerLocation";
export * from "./DeskCheckin";
export * from "./Device";
export * from "./Dms";
export * from "./DmsWarning";
export * from "./Domain";
export * from "./ExactCategoryLicense";
export * from "./ExactFailedInvoice";
export * from "./ExactOnlineFailure";
export * from "./ExactStandaloneLicense";
export * from "./ExportEvent";
export * from "./FactoryExport";
export * from "./GenAi";
export * from "./Holding";
export * from "./Import";
export * from "./Intervention";
export * from "./InterventionElement";
export * from "./Keylocker";
export * from "./KeylockerCommunication";
export * from "./KeyloopMapping";
export * from "./Kiosk";
export * from "./KioskCommunication";
export * from "./Language";
export * from "./LeaseCompany";
export * from "./Lef";
export * from "./LoginQrCode";
export * from "./Manufacturer";
export * from "./NoteSuggestion";
export * from "./Notifications";
export * from "./Oneiplanning";
export * from "./OnlineAuth";
export * from "./ParkingGateCode";
export * from "./PausedCarCheck";
export * from "./PendingChecklist";
export * from "./Pin";
export * from "./Planitplanning";
export * from "./PreviousDmsKey";
export * from "./Publicaccount";
export * from "./Question";
export * from "./QuestionResult";
export * from "./Recall";
export * from "./ReportTemplate";
export * from "./ReportThreshold";
export * from "./Settings";
export * from "./Sharebox";
export * from "./Snooze";
export * from "./StorageLocation";
export * from "./Tag";
export * from "./Translation";
export * from "./Tyre";
export * from "./TyreDiscount";
export * from "./TyremotionAi";
export * from "./TyreScanner";
export * from "./Tyreteam";
export * from "./User";
export * from "./UserFilter";
export * from "./UserSession";
export * from "./Webhook";
